import { ItemList } from '../orm'

class FaxCostStructureList extends ItemList {
    getEntityKey() {
        return "fax_cost_structure"
    }
}

export const faxCostStructureList = new FaxCostStructureList("fax_cost_structure__default")
